import { render, staticRenderFns } from "./ds-page-header.vue?vue&type=template&id=4c4390f0&scoped=true"
import script from "./ds-page-header.vue?vue&type=script&lang=js"
export * from "./ds-page-header.vue?vue&type=script&lang=js"
import style0 from "./ds-page-header.vue?vue&type=style&index=0&id=4c4390f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4390f0",
  null
  
)

export default component.exports